// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__26pUP","dragIcon":"SortableItem_dragIcon__3v2GR","disabled":"SortableItem_disabled__1xWm7"};